export default {"topContainer":"meSmF","question-div":"q1DFV","assistant-text-fib":"_2j26D","extra-styles":"IMHXZ"};